// extracted by mini-css-extract-plugin
module.exports = {"vch3g2":"vch3g2","tv5554z":"tv5554z"};